import React, {useState} from 'react';
import {Card, CardHeader, CardContent, CardActions, Button} from '@material-ui/core';
import './App.css';
// import { Fragment } from 'react';

export default function Datasheet(){
    const [maxNumberOfPages] = useState(3);
    const [page, setPage] = useState(0);

    const downloadPDF = async () => {
        const response = await fetch('/archives/Datenblatt_Luftwächter_GWS.pdf', {method: 'GET'});
        try{
            const blob = await response.blob();
            let pdf = document.createElement('a');
            pdf.href = window.URL.createObjectURL(blob);
            pdf.setAttribute('download', `GWS_Luftwächter_Datenblatt`);
            pdf.click();
        }catch(err){
            console.log(err)
        };
    };

    return (
        <Card style={{ boxShadow:"0 8px 40px -12px rgba(0,0,0,0.3)", minWidth: 415, width:"70vw" }}>
            <CardHeader title={`Luftwächter® - Messstation als Montageset`} />
            <CardContent>
                { 
                    page === 0 && 
                    <div style={{minHeight:300, position:"relative", width:"100%"}}>
                        <img src="/pictures/mietpreis.png" style={{width: 300, height:300, position:"absolute", bottom:10, right:20, zIndex:1, opacity:0.5}}/>
                        <ul style={{height:"70%", margin:0, display:"flex", flexDirection:"column", justifyContent:"space-around", padding:0, zIndex:3, position:"relative"}}>
                            <li style={{listStyleType:"none"}}><input type="checkbox" checked={true} disabled/>Erfassung von gas- und partikelförmigen Luftschadstoffen</li>
                            <li style={{listStyleType:"none"}}><input type="checkbox" checked={true} disabled/>energieautarker Betrieb mit Solarpanel und Akku</li>
                            <li style={{listStyleType:"none"}}><input type="checkbox" checked={true} disabled/>Montagefreundlich mit Universalhalterung für vorhandene Maste</li>
                            <li style={{listStyleType:"none"}}><input type="checkbox" checked={true} disabled/>einfaches Anschließen aller Komponenten</li>
                            <li style={{listStyleType:"none"}}><input type="checkbox" checked={true} disabled/>Intelligentes Energiemanagement</li>
                            <li style={{listStyleType:"none"}}><input type="checkbox" checked={true} disabled/>Datenkommunikation über Mobilfunk</li>
                            <li style={{listStyleType:"none"}}><input type="checkbox" checked={true} disabled/>Visualisierung und Bereitstellung der Daten über Web-Portal</li>
                            <li style={{listStyleType:"none"}}><input type="checkbox" checked={true} disabled/>Mietkonzept</li>
                        </ul>
                        
                    </div>
                }
                {
                    page === 1 && 
                    <Tabelle/>
                }
                {
                    page === 2 && 
                    <Kontakt/>
                }
            </CardContent>
            <CardActions style={{backgroundColor: "rgb(140, 208, 0, 0.4)"}}>
                <Button disabled={page <= 0} onClick={() => setPage(page - 1)}>{"<"}</Button>
                <Button disabled={page >= maxNumberOfPages - 1} onClick={() => setPage(page + 1)}>{">"}</Button>
                <Button onClick={() => downloadPDF()}>Datenblatt herunterladen</Button>
            </CardActions>
        </Card>
    );
}


function Tabelle(){
    return (
        <div style={{position:"relative", width:"100%"}}>
            <table style={{position:"relative", zIndex:3}}>
                <thead>
                    <tr>
                        <th className="table-cell">Bezeichnung</th>
                        <th className="table-cell">Beschreibung und Nennwerte</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="table-cell">Messung folgender Werte</td>
                        <td className="table-cell">
                            Stickstoffdioxid NO<span><sub>2</sub></span>, Stickstoffmonoxid NO, Ozon O<span><sub>3</sub></span>, Kohlenstoffmonoxid CO,
                            Feinstaub PM<span><sub>2.5</sub></span> und PM<span><sub>10</sub></span>, Temperatur, Luftdruck und Luftfeuchtigkeit
                        </td>
                    </tr>
                    <tr>
                        <td className="table-cell">Messintervall</td>
                        <td className="table-cell">5 min. für alle Gase, 10 min. für Feinstaub</td>
                    </tr>
                    <tr>
                        <td className="table-cell">Übertragungsintervall</td>
                        <td className="table-cell">alle 15 min</td>
                    </tr>
                    <tr>
                        <td className="table-cell">Leistungsaufnahme</td>
                        <td className="table-cell">ca. 2 W</td>
                    </tr>
                    <tr>
                        <td className="table-cell">Montagehöhe</td>
                        <td className="table-cell">1,5 m bis 4,0 m je nach Örtlichkeit</td>
                    </tr>
                    <tr>
                        <td className="table-cell">Halterung</td>
                        <td className="table-cell">Universalhalterung für Mastdurchmesser von 60mm bis 400mm</td>
                    </tr>
                    <tr>
                        <td className="table-cell">Gewicht</td>
                        <td className="table-cell">ca. 50 kg inkl. Transportkoffer</td>
                    </tr>
                </tbody>
            </table>
            <img src="/pictures/lw_gehaeuse.png" style={{width: 150, height:200, position:"absolute", bottom:30, left:20, zIndex:1, opacity:0.5}}/>
            <img src="/pictures/luftwaechter.png" style={{width: 150, height:300, position:"absolute", bottom:30, right:20, zIndex:1, opacity:0.5}}/>
        </div>
        
    );
};

function Kontakt(){
    return(
        <div style={{position:"relative", width:"100%"}}>
            <div style={{position:"relative", zIndex:3}}>
                <h4>Kontakt</h4>
                <p>Green Way Systems GmbH</p>
                <p>Im Rollfeld 40</p>
                <p>D-76532 Baden-Baden</p>
                <p>Telefon: +49 (7221) 189 56 - 80</p>
                <p>Telefax: +49 (7221) 189 56 - 99</p>
                <p>Mail: info@greenwaysystems.de</p>
                <p>Web: <span><a href={"https://greenwaysystems.de/"}>https://greenwaysystems.de/</a></span></p>
            </div>
            <img src="/pictures/gws_schild.png" style={{width: 180, height:300, position:"absolute", bottom:30, right:20, zIndex:1, opacity:0.5}}/>
        </div>
    )
};